module.exports = __webpack_public_path__ + "img/f3.bf84cad7.jpg";